import React from "react";
import "../theme/Administracion.css";
import { AzureAD, AuthenticationState } from "react-aad-msal";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { TableAdministracionAccesos } from "../components/TableAdministracionAccesos";
import { authProvider } from "../context/authProvider";
import { BtnGoBack } from "../components/Buttons/BtnGoBack";

export const AdminPageAcessos = () => {
  return (
    <AzureAD provider={authProvider}>
      {({ authenticationState, accountInfo }) => {
        const isAuthenticated = authenticationState === AuthenticationState.Authenticated;

        if (isAuthenticated) {
          return (
            <div className="body-color">
              <div className="title-name-admin">
                <BtnGoBack caption="Volver a administración" />
              </div>

              <TableAdministracionAccesos />
            </div>
          );
        }
      }}
    </AzureAD>
  );
};
